module.exports = __webpack_public_path__ + "media/images/ipaf_3a-8d8b2aacc1521a46aca7f1f0026265d8.png";